import { useEffect } from "react";
import { Link } from "react-router-dom";
import PageBg from "@/components/welp/PageBg";
import { showBanner } from "@/lib/banner";
import { Heart } from "lucide-react";

export default function GoodbyePage() {
  useEffect(() => { showBanner("See you soon. Love you bye!"); }, []);
  return (
    <PageBg>
      <section className="min-h-[80vh] flex flex-col items-center justify-center px-6 text-center" data-testid="goodbye-page">
        <div className="text-veil">
          <div className="text-sm uppercase tracking-[0.32em] font-bold mb-4">
            <span className="text-[#10B981]">Welp</span> <span className="text-[#5A5A5A]">·</span> <span className="text-[#FF1A82]">Dating With Integrity</span>
          </div>
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-[#10B981]">See you soon.</h1>
          <h2 className="font-heading text-4xl md:text-6xl font-bold text-[#FF1A82] mt-2">Love you bye!</h2>
          <p className="mt-6 text-lg text-[#3A3A3A] font-semibold">Leave a light on — we will too.</p>
          <Link to="/" data-testid="goodbye-home-btn"
            className="mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#10B981] text-white text-lg font-bold hover:brightness-110 transition">
            <Heart className="w-5 h-5" /> Come back in
          </Link>
        </div>
      </section>
    </PageBg>
  );
}
